import { QuizQuestionType } from '@/components/admin/quiz/CreateQuiz/QuestionTypes/types'
import { setJwtToken } from '@/helpers/setRequestHeaders'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { Quiz } from './quizApi'

export type Question = {
    id: number
    title: string
    answer_options: string[] 
    correct_answer: string
    correct_answers_list: string[]
    type: QuizQuestionType
    quiz: Quiz
}

export type QuestionDto = {
    title: string
    answer_options?: string[] 
    correct_answer?: string
    correct_answers_list?: string[]
    type: QuizQuestionType
    quiz?: Quiz
}

export const questionApi = createApi({
    reducerPath: 'questionApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.NEXT_PUBLIC_API_ENDPOINT || 'http://megakorm.ru:3005/api',
        prepareHeaders: setJwtToken
    }),
    tagTypes: ["QUESTIONS"],
    endpoints: builder => ({
        getAllQuestions: builder.query<Question[], void>({
            query: () => ({ url: `/quiz-question` }),
            providesTags: ["QUESTIONS"]
        }),
        getAllQuestionsEn: builder.query<Question[], []>({
            query: () => ({ url: `/quiz-question` }),
            providesTags: ["QUESTIONS"]
        }),
        getQuestion: builder.query<Question, { id: number }>({
            query: ({ id }) => ({ url: `/quiz-question/${id}` }),
            extraOptions: {includeToken: false},
            providesTags: ["QUESTIONS"]
        }),
        createQuestion: builder.mutation<any, QuestionDto>({
            query: data => ({ url: `/quiz-question`, method: 'POST', body: data }),
            extraOptions: {includeToken: true},
            invalidatesTags: ["QUESTIONS"]
        }),
        deleteQuestionsById: builder.mutation<any, {id: number}>({
            query: data => ({ url: `/quiz-question/${data.id}`, method: 'DELETE', body: data }),
            extraOptions: {includeToken: true},
            invalidatesTags: ["QUESTIONS"]
        }),
        deleteQuestionsByIds: builder.mutation<any, any>({
            query: data => ({ url: `/quiz-question/delete-by-ids`, method: 'POST', body: data }),
            extraOptions: {includeToken: true},
            invalidatesTags: ["QUESTIONS"]
        }),
        updateQuestion: builder.mutation<any, any>({
            query: data => {
                let id = data.id
                delete data.id
                return{ url: `/quiz-question/${id}`, method: 'PATCH', body: data }
            },
            extraOptions: {includeToken: true},
            invalidatesTags: ["QUESTIONS"]
        }),
        updateQuestionsEn: builder.mutation<any, any>({
            query: data => ({ url: `/quiz-question/en/update/${data.id}`, method: 'PATCH', body: {name: data.name, post: data.post} }),
            invalidatesTags: ["QUESTIONS"]
        }),
    })
})

export const {
    useGetAllQuestionsQuery,
    useGetAllQuestionsEnQuery,
    useGetQuestionQuery,
    useCreateQuestionMutation,
    useDeleteQuestionsByIdMutation,
    useDeleteQuestionsByIdsMutation,
    useUpdateQuestionMutation,
    useUpdateQuestionsEnMutation
} = questionApi
